import { IEmployee } from "@gtmhub/employees";
import { ITeam } from "@gtmhub/teams";
import { IdMap } from "@gtmhub/util";
import { IMetric } from "@gtmhub/okrs/metrics";

export function createEmployeeAndTeamMap(employee: IEmployee, teams: ITeam[]): IdMap<IEmployee | ITeam> {
  const map: IdMap<IEmployee | ITeam> = {};
  map[employee.id] = employee;
  teams.forEach((team) => (map[team.id] = team));
  return map;
}

export const isToDoMetric = (metric: IMetric) => {
  return !metric.insightName && !metric.sourceMetricId && metric.goalClosedStatus.status === "active" && metric.attainment < 1;
};
